<template>
  <div class="basic_copyright" v-if="
    $store.state.app.isPrivacyPolicyShow
    || $store.state.app.isTagShow
    || module.data.listArr.showTag === 'show'
    || module.data.listArr.make_isShow == 'show'
    || $store.state.vip.switch && ($store.state.myRender.common.vip_type_footer === 'default' || $store.state.app.view_pattern === 'mb')
    || zxtVisible
  ">
    <div class="tag-line">
      <div v-if="$store.state.app.isTagShow" class="tag-item" :class="{'tag-item-right': $store.state.app.isPrivacyPolicyShow}">Tag</div>
      <div class="create" v-if="$store.state.app.isPrivacyPolicyShow"> {{getLang($t('widgets_basic_copyright_index_484'))}} </div>
    </div>

    <div v-if="module.data.listArr.showTag === 'show'">{{ module.data.listArr.words }}</div>
    <div class="create" v-if="module.data.listArr.make_isShow == 'show'">{{$t('widgets_basic_copyright_index_485')}}</div>
    <div
      class="vip_logo_footer"
      v-if="$store.state.vip.switch && ($store.state.myRender.common.vip_type_footer === 'default' || $store.state.app.view_pattern === 'mb')"
    >
      <div class="big_vip_part" v-show="$store.state.app.view_pattern === 'pc' && zxtVisible">
        <div class="base_big_vip_part main_big_vip_part">
          <div class="big_vip_icon">
            <img src="https://staticjs.71360.com/3/static/image/big_vip_icon.png"/>
          </div>
          <div class="words_content">
            <p class="base_word">{{$t('widgets_basic_copyright_index_486')}}</p>
          </div>
          <div class="words_content day_part" id="rotatey1">
            <p class="day_number">
              {{ $store.state.vip.day }}
              <span>{{$t('widgets_basic_copyright_index_487')}}</span>
            </p>
            <p class="show_tag">{{$t('widgets_basic_copyright_index_488')}}</p>
          </div>
        </div>
      </div>
      <div class="mb_big_vip_part" v-show="$store.state.app.view_pattern === 'mb' && zxtVisible">
        <div class="base_mb_big_vip_part main_big_vip_part">
          <div class="big_vip_icon">
            <img src="https://staticjs.71360.com/3/static/image/big_vip_icon.png"/>
          </div>
          <div class="words_content">
            <p class="base_word">{{$t('widgets_basic_copyright_index_486')}}</p>
          </div>
        </div>
        <div class="base_mb_big_vip_part other_big_vip_part">
          <div class="big_vip_icon">
            <img src="https://staticjs.71360.com/3/static/image/big_vip_icon.png"/>
          </div>
          <div class="words_content">
            <p class="day_number">
              {{ $store.state.vip.day }}
              <span>{{$t('widgets_basic_copyright_index_487')}}</span>
            </p>
            <p class="show_tag">{{$t('widgets_basic_copyright_index_488')}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: 'basic_copyright',
  props: {
    module: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      n: 0,
      x: 0,
      rotINT: null
    }
  },
  computed: {
    zxtVisible() {
      return Number(this.$store.state.app.road_type) !== 1
    }
  },
  mounted() {
    const _this = this
    if (typeof this.module.data.listArr.make_isShow == 'undefined') {
      this.$set(this.module.data.listArr, 'make_isShow', 'show')
    }
    $('.big_vip_part .main_big_vip_part').mouseleave(function () {
      $('.words_content').css('display', 'inline-block')
      $('.day_part').css('display', 'none')
      _this.n = 0
      clearInterval(_this.rotINT)
    })
    $('.big_vip_part .main_big_vip_part').mouseenter(function () {
      if (_this.n === 0) {
        $('.words_content').css('display', 'none')
        $('.day_part').css('display', 'inline-block')
        _this.x = document.getElementById('rotatey1')
        clearInterval(_this.rotINT)
        _this.rotINT = setInterval(_this.startRotate, 36)
      }
    })
  },
  methods: {
    startRotate(n) {
      const _this = this
      _this.n = _this.n + 18
      _this.x.style.transform = 'rotateY(' + _this.n + 'deg)'
      _this.x.style.webkitTransform = 'rotateY(' + _this.n + 'deg)'
      _this.x.style.OTransform = 'rotateY(' + _this.n + 'deg)'
      _this.x.style.MozTransform = 'rotateY(' + _this.n + 'deg)'
      if (_this.n == 360) {
        clearInterval(_this.rotINT)
        if (_this.n == 360) {
          _this.n = 0
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.basic_copyright {
  padding: 10px 0;
  line-height: 22px;
  font-size: 12px;
  text-align: center;
  cursor: default;
  .tag-line{
    display: flex;
    justify-content: center;
    .tag-item{
      color: #657180;
      &-right{
        margin-right:20px;
      }
    }
  }
  .vip_logo_footer {
    .big_vip_part {
      margin: 10px auto;
      width: 134px;
      height: 50px;
      // position: absolute;
      // z-index: 997;
    }

    .big_vip_part.inline {
      display: inline-block;
      margin: 0;
      margin-left: 10px;
      vertical-align: middle;
    }

    .big_vip_part .base_big_vip_part {
      width: 134px;
      height: 50px;
      background: url(https://staticjs.71360.com/3/static/image/big_vip_bg.png) no-repeat;
      overflow: hidden;
      background-size: 100% 100%;
      font-size: 0;
      text-align: left;
    }

    .big_vip_part .base_big_vip_part .big_vip_icon {
      display: inline-block;
      vertical-align: middle;
      height: 38px;
      margin: 6px 8px;
      width: 40px;
    }

    .big_vip_part .base_big_vip_part .big_vip_icon img {
      max-height: 100%;
      max-width: 100%;
    }

    .big_vip_part .base_big_vip_part .words_content {
      height: 38px;
      display: inline-block;
      vertical-align: middle;
      color: #fff !important;
      width: 50%;
      text-align: center;
    }

    .big_vip_part .base_big_vip_part .words_content .base_word {
      font-size: 16px;
      font-weight: bold;
      font-family: 'SourceHanSansCN Bold';
      line-height: 38px;
      color: #fff;
    }

    .big_vip_part .base_big_vip_part .words_content .day_number {
      font-size: 14px;
      font-weight: bold;
      font-family: 'Franklin Gothic Demi Cond';
      line-height: 20px;
      color: #fff;
    }

    .big_vip_part .base_big_vip_part .words_content .day_number span {
      font-size: 12px;
      font-weight: bold;
      font-family: 'SourceHanSansCN Regular';
      color: #fff;
    }

    .big_vip_part .base_big_vip_part .words_content .show_tag {
      font-size: 12px;
      font-family: 'SourceHanSansCN Regular';
      position: relative;
      text-align: center;
      line-height: 12px;
      color: #fff;
    }

    .big_vip_part .base_big_vip_part .words_content .show_tag::after,
    .big_vip_part .base_big_vip_part .words_content .show_tag::before {
      display: block;
      content: '';
      width: 10px;
      height: 1px;
      background-color: #fff;
      position: absolute;
      top: 6px;
    }

    .big_vip_part .base_big_vip_part .words_content .show_tag::after {
      right: -1px;
    }

    .big_vip_part .base_big_vip_part .words_content .show_tag::before {
      left: 1px;
    }

    .big_vip_part .base_big_vip_part .words_content.day_part {
      /* display: none; */
      /* margin-left: 5px; */
    }

    .big_vip_part .base_big_vip_part:hover .words_content {
      /* display: none; */
    }

    .big_vip_part .base_big_vip_part:hover .words_content.day_part {
      /* display: inline-block; */
    }

    .mb_big_vip_part {
      margin: 5px auto;
      width: 269px;
      font-size: 0;
    }

    .mb_big_vip_part .base_mb_big_vip_part {
      width: 134px;
      height: 50px;
      display: inline-block;
      background: url(https://staticjs.71360.com/3/static/image/big_vip_bg.png) no-repeat;
      background-size: 100% 100%;
    }

    .mb_big_vip_part .base_mb_big_vip_part .big_vip_icon {
      display: inline-block;
      vertical-align: middle;
      height: 38px;
      margin: 6px 8px;
      width: 40px;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content {
      height: 38px;
      display: inline-block;
      vertical-align: middle;
      color: #fff;
      text-align: center;
      width: 50%;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content .base_word {
      font-size: 16px;
      font-weight: bold;
      font-family: 'SourceHanSansCN Bold';
      line-height: 38px;
      color: #fff;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content .day_number {
      font-size: 14px;
      font-weight: bold;
      font-family: 'Franklin Gothic Demi Cond';
      line-height: 20px;
      margin-bottom: 0;
      color: #fff;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content .day_number span {
      font-size: 12px;
      font-weight: bold;
      font-family: 'SourceHanSansCN Regular';
      color: #fff;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content .show_tag {
      font-size: 12px;
      font-family: 'SourceHanSansCN Regular';
      position: relative;
      text-align: center;
      line-height: 12px;
      color: #fff;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content .show_tag::after,
    .mb_big_vip_part .base_mb_big_vip_part .words_content .show_tag::before {
      display: block;
      content: '';
      width: 10px;
      height: 1px;
      background-color: #fff;
      position: absolute;
      top: 5px;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content .show_tag::after {
      right: -1px;
    }

    .mb_big_vip_part .base_mb_big_vip_part .words_content .show_tag::before {
      left: -1px;
    }

    .mb_big_vip_part .base_mb_big_vip_part .big_vip_icon img {
      max-width: 100%;
      max-height: 100%;
    }
  }
}
.icp_info {
  color:#657180;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_copyright/index.vue